import Metadata from '../Metadata'
import Platform from './Platform'
import style from '../../styles/components/where-to-watch/where-to-watch'

const WhereToWatchDetails = ({ where2watch: { title, description, thumbnail, platforms } }) => (
  <>
    <Metadata metadata={{ title: `Cheddar News - ${title}`, thumbnail, description }} />
    <div className='container'>
      <div className='where-to-watch-wrapper'>
        <div className='title'>{title}</div>
        <div className='content'>WATCH CHEDDAR NEWS NOW</div>
        <div className='platforms-container'>
          {platforms.map((platform) => (
            <Platform key={platform?.url} platform={platform} />
          ))}
        </div>
      </div>
    </div>
    <style jsx>{style}</style>
  </>
)

export default WhereToWatchDetails
